import styled, { css } from 'styled-components';
import { convertJsToCssVar, isDarkBackground } from '../../utils/color.js';

var TapeRow = styled.span.withConfig({
  displayName: "Tapestyle__TapeRow",
  componentId: "sc-1nmkhe9-0"
})(["background:var(--color-white);box-shadow:var(--elevation-100);border-radius:var(--border-radius-200);display:inline-flex;align-items:center;font-family:var(--font-family-thomas-headline);font-weight:700;font-size:1.9rem;line-height:3.2rem;padding:0 var(--space-300);text-transform:uppercase;white-space:pre-line;", " ", ""], function (_ref) {
  var $color = _ref.$color;
  if (!$color) {
    return '';
  }
  switch ($color) {
    case 'teal':
      return css(["background:var(--color-teal-300);"]);
    case 'sunlight':
      return css(["background:var(--color-sunlight-400);"]);
    default:
      return css(["background:", ";"], convertJsToCssVar($color));
  }
}, function (_ref2) {
  var $color = _ref2.$color,
    $firstRow = _ref2.$firstRow;
  return $color && $firstRow && css(["color:", ";"], isDarkBackground($color) ? 'var(--color-text-inverse)' : 'var(--color-text)');
});
var Tape = styled.div.withConfig({
  displayName: "Tapestyle__Tape",
  componentId: "sc-1nmkhe9-1"
})(["color:var(--color-text);"]);

export { Tape, TapeRow };
//# sourceMappingURL=Tape.style.js.map
